import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-master',
  templateUrl: './master.component.html',
  styleUrls: ['./master.component.css']
})
export class MasterComponent implements OnInit {
  includeNavTab: boolean = false;
  constructor(private router: Router) { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/components/master/master.component.ts